import React, { useEffect, useState } from 'react';
import { Row, Col, Divider } from 'antd';
import styles from './styles.module.less';

const FamilyDetails = ({ profiles }) => {
  const [familyData, setFamilyData] = useState({
    familyStatus: 'Not provided',
    familyValues: 'Not provided',
    familyType: 'Not provided',
    mother: {},
    father: {},
    brothers: {},
    sisters: {}
  });

  useEffect(() => {
    if (profiles?.length > 0) {
      // Extract basic family details
      const {
        FamilyStatus,
        FamilyType,
        FamilyValue,
        ProfileFamilies,
        ProfileSiblings
      } = profiles[0];

      // Extract parent details
      const mother =
        ProfileFamilies?.find((p) => p.parent_type === 'mother') || {};
      const father =
        ProfileFamilies?.find((p) => p.parent_type === 'father') || {};

      // Extract brother details (assuming "brother" is indicated by gender or type)
      // Extract sibling details from the correct object
      const brothers =
        ProfileSiblings?.filter((s) => s.sibling_type === 'brother') || [];
      const sisters =
        ProfileSiblings?.filter((s) => s.sibling_type === 'sister') || [];

      // Get brothers' names and marital status
      const brothersInfo = brothers.map((brother) => ({
        name: brother.sibling_name || 'Not provided',
        maritalStatus: brother.MaritalStatus?.marital_status || 'Not provided'
      }));

      // Get sisters' names and marital status
      const sistersInfo = sisters.map((sister) => ({
        name: sister.sibling_name || 'Not provided',
        maritalStatus: sister.MaritalStatus?.marital_status || 'Not provided'
      }));

      console.log('Brothers Info:', brothersInfo);
      console.log('Sisters Info:', sistersInfo);

      setFamilyData({
        familyStatus: FamilyStatus?.status || 'Not provided',
        familyValues: FamilyValue?.values || 'Not provided',
        familyType: FamilyType?.type || 'Not provided',
        mother,
        father,
        brothers: brothersInfo,
        sisters: sistersInfo
      });
    }
  }, [profiles]);
  // console.log('familyData.familyType123456', familyData.familyType);
  return (
    <>
      <Row gutter={24} className={styles.fam}>
        <Col span={8} className={styles.colStyle}>
          <span className={styles.details}>Family Status</span>
          <span className={styles.sport}> {familyData.familyStatus} </span>
        </Col>
        <Col span={8} className={styles.colStyle}>
          <span className={styles.details}>Family Values</span>
          <span className={styles.sport}> {familyData.familyValues} </span>
        </Col>
        <Col span={8} className={styles.colStyle}>
          <span className={styles.details}>Family Type</span>
          <span className={styles.sport}> {familyData.familyType} </span>
        </Col>
      </Row>
      <Divider type="horizontal"></Divider>
      <Row gutter={24} className={styles.mother}>
        <Col span={8} className={styles.colStyle}>
          <span className={styles.details}>Mother`s Name</span>
          <span className={styles.sport}>
            {' '}
            {familyData.mother.parent_name || 'Not provided'}{' '}
          </span>
        </Col>
        <Col span={8} className={styles.colStyle}>
          <span className={styles.details}>Education</span>
          <span className={styles.sport}>
            {' '}
            {familyData.mother.HigherEducation?.education ||
              'Not provided'}{' '}
          </span>
        </Col>
        <Col span={8} className={styles.colStyle}>
          <span className={styles.details}>Occupation</span>
          <span className={styles.sport}>
            {' '}
            {familyData.mother.Occupation?.occupation || 'Not provided'}{' '}
          </span>
        </Col>
      </Row>
      <Row gutter={24} className={styles.fam}>
        <Col span={8} className={styles.colStyle}>
          <span className={styles.details}>Residing</span>
          <span className={styles.sport}>
            {' '}
            {familyData.mother.residing_city || 'Not provided'}{' '}
          </span>
        </Col>
        <Col span={8} className={styles.colStyle}>
          <span className={styles.details}>Home Town</span>
          <span className={styles.sport}>
            {' '}
            {familyData.mother.home_town || 'Not provided'}{' '}
          </span>
        </Col>
      </Row>

      <Row gutter={24} className={styles.mother} style={{ paddingTop: '20px' }}>
        <Col span={8} className={styles.colStyle}>
          <span className={styles.details}>Father`s Name</span>
          <span className={styles.sport}>
            {' '}
            {familyData.father.parent_name || 'Not provided'}{' '}
          </span>
        </Col>
        <Col span={8} className={styles.colStyle}>
          <span className={styles.details}>Education</span>
          <span className={styles.sport}>
            {' '}
            {familyData.father.HigherEducation?.education ||
              'Not provided'}{' '}
          </span>
        </Col>
        <Col span={8} className={styles.colStyle}>
          <span className={styles.details}>Occupation</span>
          <span className={styles.sport}>
            {' '}
            {familyData.father.Occupation?.occupation || 'Not provided'}{' '}
          </span>
        </Col>
      </Row>
      <Row gutter={24} className={styles.fam}>
        <Col span={8} className={styles.colStyle}>
          <span className={styles.details}>Residing</span>
          <span className={styles.sport}>
            {' '}
            {familyData.father.residing_city || 'Not provided'}{' '}
          </span>
        </Col>
        <Col span={8} className={styles.colStyle}>
          <span className={styles.details}>Home Town</span>
          <span className={styles.sport}>
            {' '}
            {familyData.father.home_town || 'Not provided'}{' '}
          </span>
        </Col>
      </Row>
      <Divider type="horizontal"></Divider>

      {/* <Row className={styles.bro}>
        <Col className={styles.colStyle}>
          <span className={styles.details}>Brother</span>
          <span className={styles.sport}>
            {' '}
            {familyData.brothers.sibling_name || 'N/A'}{' '}
          </span>
        </Col>
        <Col className={styles.colStyle}>
          <span className={styles.details}>Marital Status</span>
          <Row>
            <span className={styles.sport} style={{ paddingRight: '40px' }}>
              {familyData.brothers.MaritalStatus?.marital_status || 'N/A'}{' '}
            </span>
          </Row>
        </Col>
      </Row> */}

      {/* {console.log('Brothers Data:', familyData?.brothers)} */}

      {/* {Array.isArray(familyData?.brothers) &&
      familyData?.brothers?.length > 0 ? (
        familyData.brothers.map((brother, index) => (
          <Row className={styles.bro} key={index}>
            <Col className={styles.colStyle}>
              <span className={styles.details}>Brother</span>
              <span className={styles.sport}>{brother.name || 'N/A'}</span>
            </Col>
            <Col className={styles.colStyle}>
              <span className={styles.details}>Marital Status</span>
              <Row>
                <span className={styles.sport} style={{ paddingRight: '40px' }}>
                  {brother.maritalStatus || 'N/A'}
                </span>
              </Row>
            </Col>
          </Row>
        ))
      ) : (
        <Row className={styles.bro}>
          <Col className={styles.colStyle}>
            <span className={styles.details}>Brother</span>
            <span className={styles.sport}>N/A</span>
          </Col>
          <Col className={styles.colStyle}>
            <span className={styles.details}>Marital Status</span>
            <Row>
              <span className={styles.sport} style={{ paddingRight: '40px' }}>
                N/A
              </span>
            </Row>
          </Col>
        </Row>
      )} */}
      {Array.isArray(familyData?.brothers) &&
      familyData?.brothers?.length > 0 ? (
        <>
          {/* Headers Row */}
          <Row className={styles.siblingsStyles} style={{ paddingTop: '10px' }}>
            <Col className={styles.colStyle}>
              <span className={styles.details}>Brother</span>
            </Col>
            <Col className={styles.colStyle}>
              <span className={styles.details}>Marital Status</span>
            </Col>
          </Row>

          {/* Data Rows */}
          {familyData.brothers.map((brother, index) => (
            <Row key={index} className={styles.siblingsStyles}>
              <Col className={styles.colStyle}>
                <span className={styles.sport}>
                  {brother.name || 'Not provided'}
                </span>
              </Col>
              <Col className={styles.colStyle}>
                <span className={styles.sport}>
                  {brother.maritalStatus || 'Not provided'}
                </span>
              </Col>
            </Row>
          ))}
        </>
      ) : (
        <>
          {/* Headers Row */}
          <Row className={styles.siblingsStyles}>
            <Col className={styles.colStyle}>
              <span className={styles.details}>Brother</span>
            </Col>
            <Col className={styles.colStyle}>
              <span className={styles.details}>Marital Status</span>
            </Col>
          </Row>

          {/* No Data Row */}
          <Row className={styles.siblingsStyles}>
            <Col className={styles.colStyle}>
              <span className={styles.sport}>Not provided</span>
            </Col>
            <Col className={styles.colStyle}>
              <span className={styles.sport}>Not provided</span>
            </Col>
          </Row>
        </>
      )}

      {/* <Row className={styles.bro} style={{ paddingTop: '20px' }}>
        <Col className={styles.colStyle}>
          <span className={styles.details}>Sister</span>
          <span className={styles.sport}>1</span>
        </Col>
        <Col className={styles.colStyle}>
          <span className={styles.details}>Marital Status</span>
          <Row>
            <span className={styles.sport} style={{ paddingRight: '40px' }}>
              Married - 0
            </span>
          </Row>
        </Col>
      </Row> */}

      {/* {familyData.sisters.length > 0 ? (
        familyData.sisters.map((sister, index) => (
          <Row
            className={styles.bro}
            key={index}
            style={{ paddingTop: '20px' }}
          >
            <Col className={styles.colStyle}>
              <span className={styles.details}>Sister</span>
              <span className={styles.sport}>{sister.name || 'N/A'}</span>
            </Col>
            <Col className={styles.colStyle}>
              <span className={styles.details}>Marital Status</span>
              <Row>
                <span className={styles.sport} style={{ paddingRight: '40px' }}>
                  {sister.maritalStatus || 'N/A'}
                </span>
              </Row>
            </Col>
          </Row>
        ))
      ) : (
        <Row className={styles.bro} style={{ paddingTop: '20px' }}>
          <Col className={styles.colStyle}>
            <span className={styles.details}>Sister</span>
            <span className={styles.sport}>N/A</span>
          </Col>
          <Col className={styles.colStyle}>
            <span className={styles.details}>Marital Status</span>
            <Row>
              <span className={styles.sport} style={{ paddingRight: '40px' }}>
                N/A
              </span>
            </Row>
          </Col>
        </Row>
      )} */}

      {Array.isArray(familyData?.sisters) && familyData?.sisters?.length > 0 ? (
        <>
          {/* Headers Row */}
          <Row className={styles.siblingsStyles} style={{ paddingTop: '20px' }}>
            <Col className={styles.colStyle}>
              <span className={styles.details}>Sister</span>
            </Col>
            <Col className={styles.colStyle}>
              <span className={styles.details}>Marital Status</span>
            </Col>
          </Row>

          {/* Data Rows */}
          {familyData.sisters.map((sister, index) => (
            <Row key={index} className={styles.siblingsStyles}>
              <Col className={styles.colStyle}>
                <span className={styles.sport}>
                  {sister.name || 'Not provided'}
                </span>
              </Col>
              <Col className={styles.colStyle}>
                <span className={styles.sport}>
                  {sister.maritalStatus || 'Not provided'}
                </span>
              </Col>
            </Row>
          ))}
        </>
      ) : (
        <>
          {/* Headers Row */}
          <Row className={styles.siblingsStyles}>
            <Col className={styles.colStyle}>
              <span className={styles.details}>Sister</span>
            </Col>
            <Col className={styles.colStyle}>
              <span className={styles.details}>Marital Status</span>
            </Col>
          </Row>

          {/* No Data Row */}
          <Row className={styles.siblingsStyles}>
            <Col className={styles.colStyle}>
              <span className={styles.sport}>Not provided</span>
            </Col>
            <Col className={styles.colStyle}>
              <span className={styles.sport}>Not provided</span>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default FamilyDetails;
